export interface IPromptInput {
  prompt: string
  referenceImages: string[]
}

const normalizePrompt = (text: string): string => text.trim().replace(/\s+/g, ' ')

export const isSamePromptInput = (a: IPromptInput, b: IPromptInput): boolean => {
  if (normalizePrompt(a.prompt) !== normalizePrompt(b.prompt)) return false
  const sortedA = [...a.referenceImages].sort()
  const sortedB = [...b.referenceImages].sort()
  return sortedA.length === sortedB.length && sortedA.every((url, i) => url === sortedB[i])
}
